export default "__VITE_ASSET__BVtIHXsv__"